module.exports = __webpack_public_path__ + "801ec1f397ce053afaaec29a79094857.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/bz.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/bz.svg
// module chunks = 0